import { ISectorAir, ISectorStay, ITraveller, IProperty } from "libraries/service/resources/booking/interfaces/IGetBookings";

export enum PriceLineType {
    air = 'air',
    stay = 'stay',
    detail = 'detail',
    total = 'total',
    other = 'other'
}

export enum PriceColumnType {
    total = 'total',
    traveller = 'traveller',
    detail = 'detail',
}

export interface ITablePrice {
    lines: TPriceLine[];
    columns?: TPriceColumn[];
    values?: TPriceValues;
}

export interface ILinesValues {
    lines: TPriceLine[];
    values: ICellValue[];
}

export type TPriceColumn = ITotalColumn | ITravellerColumn | ILineColumn | ITotalColumn;
export type TPriceLine = IHotelLine | IAirLine | IPriceLineDetail | ITotalLine | IOtherLine;
export type TPriceValues = Map<string, Map<string, IPriceValue>>;

export interface ICellValue {
    value: IPriceValue;
    lineKey: string;
    columnKey: string;
}

export interface IPriceLine {
    key: string;
    type: PriceLineType;
    hasChildren?: boolean;
    parentKey?: string;
}

export interface IAirLine extends IPriceLine {
    type: PriceLineType.air;
    sectors: ISectorAir[];
}

export interface IHotelLine extends IPriceLine {
    type: PriceLineType.stay;
    hotel: ISectorStay;
    property: IProperty;
}

export interface IPriceLineDetail extends IPriceLine {
    type: PriceLineType;
    text: string;
}

export interface ITotalLine extends IPriceLine {
    type: PriceLineType.total;
    text: string;
    additionalInfos?: string[];
}

export interface IOtherLine extends IPriceLine {
    type: PriceLineType.other;
    text: string;
}

export interface IPriceColumn {
    type: PriceColumnType;
    key: string;
}

export interface ILineColumn extends IPriceColumn {
    type: PriceColumnType.detail;
    text: string;
}

export interface ITotalColumn extends IPriceColumn {
    type: PriceColumnType.total;
    text: string;
}

export interface ITravellerColumn extends IPriceColumn {
    type: PriceColumnType.traveller;
    traveller?: ITraveller;
    text?: string;
}

export interface IPriceValue {
    value?: number | string;
    currency?: string;
    quantity?: number;
    additionalInfos?: string[];
    isIncluded?: boolean;
    isAutomaticallyDistributed: boolean;
}

export interface ITaxConfig {
    key: string;
    text: string;
    taxCodes: string[];
}